export const ADVERT_REQUEST = 'ADVERT_REQUEST';
export const ADVERT_SUCCESS = 'ADVERT_SUCCESS';
export const ADVERT_FAILURE = 'ADVERT_FAILURE';
export const ADVERT_CLEAR = 'ADVERT_CLEAR';
